<template>
  <div id="campanha-gripe" class="row">
    <div class="col-md-12">
      <div class="filter-select">
        <vue-select
          v-if="enableSelect != 2 && enableSelect != 3"
          :options="equipes"
          label="no_esf_eap"
          placeholder="Equipes"
          @input="onChangeEquipe"
        >
          <template slot="option" slot-scope="option">
            {{ option.no_esf_eap }}
            {{
              option.ine_esf_eap != 'sem-equipe'
                ? '- ' + option.ine_esf_eap
                : ''
            }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
        <vue-select
          :options="publicosAlvos"
          label="label"
          placeholder="Público alvo"
          @input="onChangePublicoAlvo"
          v-model="publicoAlvo"
          :disabled="equipe == null || equipe == '' ? true : false"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="full-table">
          <div class="col-md-12">
            <div class="info-table">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="setRed"
                  @resetarNome="setRed = false"
                ></Subtitle>
              </div>
              <div class="select-situacao info-table-item">
                <vue-select
                  v-if="enableSelect != 3"
                  :options="profissionais"
                  label="no_profissional"
                  placeholder="Profissionais"
                  @input="onChangeProfissional"
                  v-model="profissional"
                  :clearable="true"
                  :disabled="equipe == null || equipe == '' ? true : false"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.no_profissional }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="select-situacao info-table-item">
                <vue-select
                  :options="micro_areas"
                  label="micro_area"
                  placeholder="Microárea"
                  @input="onChangeMicroArea"
                  v-model="micro_area"
                  :clearable="true"
                  :disabled="equipe == null || equipe == '' ? true : false"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.micro_area }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="campanha-gripe"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :loading="loadingLista"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subtitle from './Subtitle'
import * as Functions from './functions.js'
import TabelaCadastros from './TabelaCadastros.vue'
import { dataFields } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Equipe from '@/services/Equipe.js'

export default {
  name: 'CampanhaGripePorEquipe',
  components: {
    Subtitle,
    DownloadFiles,
    TabelaCadastros,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: null,
      profissionais: [],
      profissional: null,
      micro_areas: [],
      micro_area: null,
      cadastrosOriginais: [],
      cadastros: [],
      loadingLista: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      setRed: false,
      publicosAlvos: [
        {
          label: 'Pessoas com mais de 60 anos',
          value: 'pessoas-60-anos',
        },
        {
          label: 'Crianças de 6 meses a 5 anos, 11 meses e 29 dias',
          value: 'criancas-6meses-4anos',
        },
        {
          label: 'Gestantes ou Puérperas',
          value: 'gestantes',
        },
        {
          label: 'Hipertensos',
          value: 'hipertensos',
        },
        {
          label: 'Diabetes',
          value: 'diabetes',
        },
      ],
      publicoAlvo: null,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    equipes() {
      return this.$store.state.equipesV2
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Aplica o filtro de exibição de cadastros (vermelhos ou verdes).
     * @param {Boolean} vermelho Indica se o filtro de vermelhos deve ser aplicado
     * @param {Boolean} verde Indica se o filtro de verdes deve ser aplicado
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.equipe = event
      this.publicoAlvo = null
      this.profissional = null
      this.profissionais = []
      this.cadastrosOriginais = []
      this.cadastros = []
      if (this.equipe != null) {
        try {
          this.micro_areas = Equipe.carregarMicroAreasPorEquipeLocal(
            this.equipe.ine_esf_eap
          )
          this.profissionais = await Equipe.getProfissionaisAcsPorEquipe(
            this.$store.state.cod_ibge,
            this.equipe.ine_esf_eap
          )
        } catch (error) {
          console.log(error)
        }
      }
    },

    /**
     * Manipula a alteração do público alvo selecionado.
     *
     * @param {Object} event Público alvo selecionada
     */
    async onChangePublicoAlvo(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.publicoAlvo = event
      this.profissional = null
      this.micro_area = null
      if (this.publicoAlvo != null) {
        try {
          this.loadingLista = true
          const response = await Functions.getDados(
            this.$store.state.cod_ibge,
            this.equipe.ine_esf_eap,
            this.publicoAlvo.value
          )
          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.filtros(true, false)
            this.setRed = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      } else {
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    /**
     * Manipula a alteração da profissional selecionado.
     *
     * @param {Object} event Profissional selecionada
     */
    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.micro_area = null
      this.profissional = event
      if (this.profissional !== null) {
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
        if (this.profissional == null) {
          this.cadastros = this.cadastrosOriginais
        } else {
          this.cadastros = this.cadastrosOriginais.filter((el) => {
            return el.profissional == this.profissional.nu_cpf
          })
        }
      } else {
        this.cadastros = []
        this.cadastrosOriginais = []
        this.onChangePublicoAlvo(this.publicoAlvo)
      }
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loadingLista = true
        this.profissional = null
        this.micro_area = event?.micro_area
        if (this.micro_area !== null) {
          const response = this.cadastrosOriginais.filter((el) => {
            return el.micro_area == this.micro_area
          })
          this.cadastros = response
          this.loadingLista = false
        }
      } else {
        this.cadastrosOriginais = []
        this.cadastros = []
        this.profissional = null
        this.micro_area = null
        this.onChangePublicoAlvo(this.publicoAlvo)
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.micro_area,
        this.publicoAlvo
      )
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            await this.onChangeEquipe(this.equipe)
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
          }
          this.micro_areas = Equipe.carregarMicroAreasPorEquipeLocal(
            this.equipe.ine_esf_eap
          )
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
